// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__jiQdi","header":"ReportDetails_header__2YKOr","title":"ReportDetails_title__HDAco","left":"ReportDetails_left__3A6Ha"};